module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAZCAYAAAD5e+QFAAAAAXNSR0IArs4c6QAAAGBJREFUKBVjZACC6JXq2///Z1JmZPx3d2n4TU9GiACjB0gSBBgZ/+9g+v+PURPChZAgPhMj0//ryIIgPiNIIHK5+nYGRgYlhv8M95ZH3vREVkRTNlbbR32EFObwOEKPdwAUD1G89zmWmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/options.png
// module id = 1217
// module chunks = 0